module.exports = __webpack_public_path__ + "static/media/activity-icon-appeal-ruling.56202b99.svg";